module.exports = __webpack_public_path__ + "img/hero-eam.869d2837.jpg";